import { render } from "./NewTravel.vue?vue&type=template&id=8462feae&scoped=true"
import script from "./NewTravel.vue?vue&type=script&lang=js"
export * from "./NewTravel.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./NewTravel.vue?vue&type=style&index=1&id=8462feae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8462feae"]])

export default __exports__